export default __webpack_public_path__ + "static/media/1.4f683fe8.png";